import React, { createContext } from 'react'
import { AuthLayoutConfig } from '../types/authLayout/types'

export const AuthLayoutContext = createContext<AuthLayoutConfig | null>(null)

export const AuthLayoutProvider = ({
    config,
    children,
}: {
    config: AuthLayoutConfig
    children: React.ReactNode
}): React.ReactElement => (
    <AuthLayoutContext.Provider value={config}>{children}</AuthLayoutContext.Provider>
)
